/**
 * The Autopilot's answer key.
 *
 * The non-production Autopilot (ticket 17) drives the real UI, so it needs the
 * same knowledge a learner has: which chip it is looking at, which marker is
 * which. Those hooks are plain `data-autopilot` attributes on the controls, and
 * they are inert — no styling, no behaviour, nothing a learner could read.
 *
 * Three of them are not inert, because they *are* the answer: which option is
 * correct, which region is the rip, which order the steps go in. Those go
 * through this helper, which is compiled out of a production build —
 * `__QA_WIDGET_ENABLED__` is a build-time constant (see `vite.config.ts`), so
 * the branch folds away and a learner's DOM never carries the answer.
 */
export function answerKey(value: string | boolean): Record<string, string> | undefined {
  if (!__QA_WIDGET_ENABLED__ || value === false) {
    return undefined;
  }

  return { 'data-autopilot-key': value === true ? '' : value };
}
